module.exports = __webpack_public_path__ + "img/product1.308221d7.png";